import { openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-propertyDetails"
}
const _hoisted_2 = { class: "o-propertyDetails__imageColumn" }
const _hoisted_3 = { class: "o-propertyDetails__imageWrapper" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "o-propertyDetails__imageWrapper" }
const _hoisted_6 = {
  ref: "swiper",
  class: "swiper"
}
const _hoisted_7 = { class: "swiper-wrapper" }
const _hoisted_8 = ["src", "srcset", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "o-propertyDetails__detailsText" }
const _hoisted_11 = {
  key: 0,
  class: "o-propertyDetails__detailsNavigation"
}
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!

  return ($options.currentImage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["o-propertyDetails__row", { 'o-propertyDetails__row--leftAligned': $props.leftAligned }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("img", {
                    key: `image-${$options.currentImage.id}`,
                    class: "o-propertyDetails__image",
                    src: `${$options.currentSrc}&width=1000`,
                    alt: $options.currentImage.description
                  }, null, 8 /* PROPS */, _hoisted_4))
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ], 512 /* NEED_PATCH */), [
              [_vShow, $data.isDesktop]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createCommentVNode(" Slider main container "),
              _createElementVNode("div", _hoisted_6, [
                _createCommentVNode(" Additional required wrapper "),
                _createElementVNode("div", _hoisted_7, [
                  _createCommentVNode(" Slides "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.images, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `image-${image.id}`,
                      class: "swiper-slide"
                    }, [
                      _createElementVNode("img", {
                        loading: "lazy",
                        src: `${image.url}&width=600`,
                        srcset: `${image.url}&width=600 600w, ${image.url}&width=900 900w, ${image.url}&width=1200 1200w`,
                        alt: image.description
                      }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createCommentVNode(" If we need pagination "),
                _hoisted_9,
                _createCommentVNode(" If we need navigation buttons "),
                _createCommentVNode(" <div class=\"swiper-button-prev\"></div>\n                        <div class=\"swiper-button-next\"></div> "),
                _createCommentVNode(" If we need scrollbar "),
                _createCommentVNode(" <div class=\"swiper-scrollbar\"></div> ")
              ], 512 /* NEED_PATCH */)
            ], 512 /* NEED_PATCH */), [
              [_vShow, !$data.isDesktop]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["o-propertyDetails__detailsColumn", {
                    'o-propertyDetails__detailsColumn--leftAligned':
                        $props.leftAligned,
                }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _renderSlot(_ctx.$slots, "headline"),
              _renderSlot(_ctx.$slots, "description")
            ]),
            ($data.isDesktop && $props.images.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "o-propertyDetails__detailsProgress",
                    textContent: _toDisplayString(`${$data.currentIndex + 1} / ${$props.images.length}`)
                  }, null, 8 /* PROPS */, _hoisted_12),
                  _createElementVNode("div", {
                    class: "o-propertyDetails__navigationButton",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.prev()))
                  }, [
                    _createVNode(_component_a_icon, { name: "arrow_back" })
                  ]),
                  _createElementVNode("div", {
                    class: "o-propertyDetails__navigationButton",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.next()))
                  }, [
                    _createVNode(_component_a_icon, { name: "arrow_forward" })
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */)
      ]))
    : _createCommentVNode("v-if", true)
}